import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./AuthProtected";
import ProtectedRoute from "./moduleProtectedRoutes";

const Index = () => {
  return (
    <Routes>
      {/* Default redirect - first URL hit should go to /services (public web courses, no auth) */}
      <Route path="/" element={<Navigate to="/services" replace />} />

      {/* Public Routes */}
      <Route element={<NonAuthLayout />}>
        {publicRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.component} />
        ))}
      </Route>

      {/* Protected Routes */}
      <Route
        element={
          <AuthProtected>
            <VerticalLayout />
          </AuthProtected>
        }
      >
        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <ProtectedRoute constant={route.constant}>
                {route.component}
              </ProtectedRoute>
            }
          />
        ))}

        {/* Redirects inside protected area */}
        <Route index element={<Navigate to="/course" />} />
        <Route path="*" element={<Navigate to="/course" />} />
      </Route>
    </Routes>
  );
};

export default Index;
